import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import IItemsConsulta from 'Infotrack@Modelos/smartStock/items/entidades/IItemsConsulta';

interface ICampoDescripcionItemProps {
    deshabilitado: boolean;
    items?: IItemsConsulta[];
    manejarCambioCampo: (
        nombreCampo: keyof IDocumentoDetalle,
        nuevoValor: IItemsConsulta | null
    ) => any;
    valor: number | undefined;
}

const CampoDescripcionItem: FunctionComponent<ICampoDescripcionItemProps> = ({
    deshabilitado,
    items,
    manejarCambioCampo,
    valor,
}) => (
    <Autocomplete
        disabled={deshabilitado}
        onChange={(_: ChangeEvent<{}>, value: IItemsConsulta | null) =>
            manejarCambioCampo('ItemId', value )
        }
        options={items || []}
        getOptionLabel={(i) => i.DescripcionItem}
        renderInput={(params) => (
            <TextField
                {...params}
                required
                fullWidth
                label={<Texto id="DetallesFormulario.CampoDescripcionItem.Nombre" />}
            />
        )}
        value={items ? items.find((i) => i.ItemId === valor) || null : null}
        id={`CampoDescripcion`}
    />
);

export default CampoDescripcionItem;
